var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1264 9.83333C11.5364 9.83333 9.43641 7.745 9.43641 5.155C9.43641 4.32667 9.65807 3.51 10.0664 2.79833H3.35807L3.32307 2.51833C3.18307 1.34 2.17974 0.441666 0.989739 0.441666H0.826406C0.394739 0.441666 0.0447388 0.791665 0.0447388 1.22333C0.0447388 1.655 0.394739 2.005 0.826406 2.005H1.00141C1.39807 2.005 1.73641 2.29667 1.78307 2.69333L2.85641 11.8517C3.08974 13.8233 4.75807 15.305 6.74141 15.305H14.9081C15.3397 15.305 15.6897 14.955 15.6897 14.5233C15.6897 14.0917 15.3397 13.7417 14.9081 13.7417H6.74141C5.74974 13.7417 4.86307 13.1117 4.53641 12.1783H13.8581C15.7481 12.1783 17.3697 10.825 17.7081 8.95833L17.8947 7.93166C17.0081 9.12167 15.6081 9.83333 14.1264 9.83333Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.5164 19.225C6.3798 19.225 7.07973 18.5251 7.07973 17.6617C7.07973 16.7983 6.3798 16.0983 5.5164 16.0983C4.65299 16.0983 3.95306 16.7983 3.95306 17.6617C3.95306 18.5251 4.65299 19.225 5.5164 19.225Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3447 19.225C14.2081 19.225 14.9081 18.5251 14.9081 17.6617C14.9081 16.7983 14.2081 16.0983 13.3447 16.0983C12.4813 16.0983 11.7814 16.7983 11.7814 17.6617C11.7814 18.5251 12.4813 19.225 13.3447 19.225Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.7814 5.925H13.3447V7.48834C13.3447 7.92 13.6947 8.27 14.1264 8.27C14.5581 8.27 14.9081 7.92 14.9081 7.48834V5.925H16.4714C16.9031 5.925 17.2531 5.575 17.2531 5.14334C17.2531 4.71167 16.9031 4.36167 16.4714 4.36167H14.9081V2.78667C14.9081 2.355 14.5581 2.005 14.1264 2.005C13.6947 2.005 13.3447 2.355 13.3447 2.78667V4.35001H11.7814C11.3497 4.35001 10.9997 4.7 10.9997 5.13167C10.9997 5.575 11.3497 5.925 11.7814 5.925Z",
    fill: "#2196F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCart);
export default __webpack_public_path__ + "static/media/blue-cart.7781edcbb4a4a3f85a54c0c1041182c4.svg";
export { ForwardRef as ReactComponent };